var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page form-page"},[_c('PageTitle',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"app-container"},[_vm._t("default")],2),_vm._v(" "),_c('NeedHelp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }